import { api } from 'services/companiesApi';

export const getCampaign = (id: string) => api.get(`/campaigns/${id}`);
